import { gql } from "@apollo/client";

const GET_PRIORITIES = gql`
  query GetPriorities {
    priorities {
      count
      items {
        label
        value
      }
    }
  }
`;

export default GET_PRIORITIES;
